import React from 'react';
import PolicyPage from './PolicyPage';

const sections = [
  {
    heading: 'Refund Eligibility',
    paragraphs: [
      'Refund or return requests are reviewed on a case-by-case basis depending on the nature of the service or transaction completed with TUR DER HOFFNUNG.',
      'If a payment was made in error, duplicated, or authorized incorrectly, the customer should contact us promptly with full transaction details for review.',
    ],
  },
  {
    heading: 'Request Process',
    paragraphs: [
      'To request a refund, customers should submit their request through our contact page and include their name, payment date, amount, and reason for the request.',
      'Approved refunds will be returned through the original payment method whenever possible.',
    ],
  },
  {
    heading: 'Non-Refundable Cases',
    paragraphs: [
      'Refunds may be declined where services have already been delivered, where the customer provided incorrect payment information, or where misuse, abuse, or fraud is suspected.',
      'Processing fees charged by banks, gateways, or payment processors may be non-refundable unless otherwise required by law.',
    ],
  },
];

export default function RefundPolicyPage() {
  return (
    <PolicyPage
      title="Refund / Return Policy"
      subtitle="Refund Policy"
      sections={sections}
    />
  );
}
